"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function createReducer(initialState, handlers) {
  return function reducer(state, action) {
    if (state === void 0) {
      state = initialState;
    }

    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };
}

exports.createReducer = createReducer;